export default __webpack_public_path__ + "static/media/assisted-ic.a6c247ef.svg";